import { Button, Col, Flex, Row, Tag, TagProps, Typography } from 'antd'
import { CSSProperties, MouseEvent } from 'react'
import {
  ProjectMemberEntity,
  UserEntity,
} from '../../../../../../../server-api-hrm.type'
import { mapMemberRoleObj } from '../constants/map.MemberRole'
import IconGlobalApp from '../../../../../../../utils/IconGlobalApp'
import { mapCommonIcons } from '../../../../../../../utils/mapCommonIcons'

const { Text } = Typography

interface IProps {
  user: UserEntity
  role?: ProjectMemberEntity['role']
  compact?: boolean
  onDelete?: (_user: UserEntity, _e?: MouseEvent<HTMLElement>) => void
  tagProps?: TagProps
}

const TagMember = ({ user, role, compact, onDelete, tagProps }: IProps) => {
  const textStyle: CSSProperties = compact
    ? {
        color: 'inherit',
        fontSize: 'inherit',
        lineHeight: 'inherit',
        fontWeight: 'inherit',
      }
    : { color: 'inherit', lineHeight: 1.4 }

  const leaderIcon =
    role === 'LEADER' && mapMemberRoleObj.LEADER?.iconName ? (
      <IconGlobalApp
        name={mapMemberRoleObj.LEADER.iconName}
        strokeWidth={0.5}
        color="#faad14"
        fill="#faad14"
        size={compact ? 14 : 16}
      />
    ) : null

  return (
    <Tag
      color={compact ? 'blue' : 'default'}
      {...tagProps}
      style={{
        paddingInline: compact ? undefined : 0,
        padding: compact ? undefined : '4px 8px',
        margin: 0,
        ...tagProps?.style,
      }}
    >
      <Row
        gutter={[compact ? 6 : 12, 0]}
        align="middle"
        wrap={false}
        style={textStyle}
      >
        <Col flex="auto" style={textStyle}>
          <Flex vertical style={textStyle}>
            <Flex gap={compact ? 4 : 6} align="center" style={textStyle}>
              {leaderIcon}
              <Text
                strong={!compact}
                style={textStyle}
                ellipsis={{ tooltip: true }}
              >
                {user.fullname}
              </Text>
            </Flex>
            {compact ? null : (
              <Text
                type="secondary"
                style={textStyle}
                ellipsis={{ tooltip: true }}
              >
                {user.email}
              </Text>
            )}
          </Flex>
        </Col>

        {typeof onDelete === 'function' ? (
          <Col>
            <Button
              type={compact ? 'link' : 'text'}
              size="small"
              icon={<IconGlobalApp name={mapCommonIcons.delete} />}
              danger
              onClick={(e) => onDelete(user, e)}
            />
          </Col>
        ) : null}
      </Row>
    </Tag>
  )
}

export default TagMember
